module.exports = __webpack_public_path__ + "static/media/YashB3.47a81b38.png";